import {LiveClassesPageV2} from "./v2";

function LiveClassesPage() {
  return <LiveClassesPageV2 />;
}

export {LiveClassesPage};
